
import { supabase } from '@/integrations/supabase/client';

/**
 * Cancels a Stripe subscription
 */
export const cancelSubscription = async (
  subscriptionId: string
): Promise<{ success: boolean; error?: string }> => {
  try {
    const { data, error } = await supabase.functions.invoke('cancel-subscription', {
      body: { subscriptionId }
    });

    if (error) {
      console.error('Error cancelling subscription:', error);
      return { success: false, error: error.message };
    }

    return { success: true };
  } catch (err) {
    console.error('Exception cancelling subscription:', err);
    return { success: false, error: err instanceof Error ? err.message : 'Une erreur est survenue' };
  }
};
